export default __webpack_public_path__ + "static/14-0ca70a2f886765b6de28048d7654acd8.png";